<template>
  <v-dialog
    v-if="value"
    :value="value"
    :max-width="maxWidth"
    :width="width"
    @click:outside="close"
    @keydown.esc="close"
  >
    <v-card :id="id" class="m-modal__card">
      <v-card-title class="d-flex justify-center m-modal__card-title">
        <div class="m-modal__title m-subtitle">
          {{ title }}
        </div>
      </v-card-title>
      <div class="pa-5">
        <slot name="content" />
      </div>
      <div
        class="d-flex justify-center align-center px-5"
        style="gap: 8px;"
      >
        <slot name="actions" />
      </div>
      <v-icon
          class="m-modal__close-btn"
          color="#A6ADB5"
          @click="close"
      >
        $cross
      </v-icon>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    maxWidth: {
      type: String,
      default: '900',
    },
    width: {
      type: String,
      default: undefined,
    },
    id: {
      type: String,
      default: undefined
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
  },
}
</script>
<style scoped lang="scss">
.m-modal{
  &__card{
    border-radius: 12px;
    padding: 32px 0;

    &-title{
      word-break: break-word;
      padding-left: 4px;
      padding-right: 4px;
    }
  }

  &__close-btn{
    position: absolute;
    right: 20px;
    top: 20px;
    width: 8px !important;
    height: 8px !important;
  }
}

</style>

<style>
.v-dialog{
  box-shadow: 0px 4px 30px 0px #33343629 !important;
}
</style>